import { Button, CardContent, Divider, Drawer, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Typography, tableCellClasses } from '@mui/material';
import { FC, useCallback, useEffect, useMemo, useState } from 'react';

import CustomDataGrid from '../../components/DataGrid/DataGrid';
import { useAppDispatch, useAppSelector, } from "../../store/hooks";
import { ApiStatus } from "../../utils/api.types";
import Link from '@mui/material/Link';
import { /* deleteBank, */ fetchBanks } from '../../store/bankStore/bankThunk';
import { Box } from '@mui/system';
import { GridActionsCellItem, GridColDef, GridValueGetterParams } from '@mui/x-data-grid';
import { IBank } from '../../utils/bank.types';
import EditIcon from '@mui/icons-material/Edit';
//import DeleteIcon from '@mui/icons-material/Delete';
import { PermissionsEnum } from "../../utils/auth.types";
import DialogBankForm from '../DialogBankForm/DialogBankForm';
import { StyledCard } from '../AccountBasicInfo/AccountBacisInfo.styles';
import styled from '@emotion/styled';
import moment from 'moment';
import DeleteIcon from '@mui/icons-material/Delete';

interface AccountBankInfoProps {
  accountId: string;
}


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#fff',
    color: '#9da7b7',
    borderTop: '0.25px solid #d9d4d4',
    borderBottom: '0.25px solid #d9d4d4',
    margin: 0,
    padding: 5,
    fontSize: 13,
    paddingLeft: '15px !important',
  },
  [`&.${tableCellClasses.footer}`]: {
    backgroundColor: '#f5f5f5',
    color: 'black',
    borderTop: '0.25px solid #d9d4d4',
    borderBottom: '0.25px solid #d9d4d4',
    left: 0,
    bottom: 0, // <-- KEY
    zIndex: 2,
    position: 'sticky'
  },
  [`&.${tableCellClasses.body}`]: {
    verticalAlign: 'super',
    fontSize: 14,
    fontWeight: 'normal',
    color: '#292d35',
    padding: 5,
    border: 'none',
    paddingLeft: '15px !important',
    margin: 0
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: '#fbfbfb',
    // border: '0.5px dashed #9da7b7',
  },
  '&:nth-of-type(odd)': {
    backgroundColor: '#e9ecf1',
    // border: '0.5px dashed #9da7b7',
  },
  // hide last border
  '&:last-child td, &:last-child th': {
  },
}));


const AccountBankInfo: FC<AccountBankInfoProps> = (props) => {
  const dispatch = useAppDispatch();

  const { banks, status } = useAppSelector(state => state.banks);
  const { permissions } = useAppSelector(state => state.auth);

  const [open, setOpen] = useState(false);
  const [bankId, setBank] = useState('');
  const [fetchData, setFetchData] = useState('');

  // const canCreateAccount = permissions?.includes(PermissionsEnum.Account_Create);
  const canUpdateAccount = permissions?.includes(PermissionsEnum.Account_Update);
  // const canViewAccount = permissions?.includes(PermissionsEnum.Account_View);
  //const canDeleteAccount = permissions?.includes(PermissionsEnum.Account_Delete);


  /**
   * Fetch all the accounts on Accounts page load.
   */
  useEffect(() => {
    dispatch(fetchBanks(props.accountId));
  }, [dispatch, fetchData, props]);

  /**
   * Handler for account name click.
   */
  const handleNameClick = useCallback((bank: IBank) => {
    openBankForm(bank._id);
  }, []);

  /**
  * Method to handle delete account.
  */
  // const deleteSelectedBank = useCallback((item: IBank) => () => {
  //   // Dispatch action to delete account.
  //   dispatch(deleteBank(item._id));
  // }, [dispatch]);

  /**
   * Method to handle delete item.
   */
  // const deleteSelected = useCallback((item: IBank) => () => {
  //   // Dispatch action to delete.
  //   dispatch(deleteBank(item._id));
  // }, [dispatch]);

  /**
   * Method to handle edit.
   */
  // const editSelected = useCallback((item: IBank) => () => {

  // }, [dispatch]);

  /**
   * Column defs for account list data grid.
   */
  const columns: GridColDef[] = useMemo(() => [
    {
      field: "bankName",
      headerName: 'Bank Name',
      type: "string",
      flex: 1,
      renderCell: ({ row, value }: GridValueGetterParams) => (
        <Typography
          sx={{ cursor: 'pointer', fontWeight: 'bold' }}
          component={Link}
          underline='hover'
          onClick={() => handleNameClick(row)}
        >
          {value}
        </Typography>
      )
    },
    {
      field: "branchName",
      headerName: 'Branch',
      type: "string",
      flex: 1
    },

    {
      field: "actions",
      headerName: 'Actions',
      type: "actions",
      flex: 1,
      getActions: (params: GridValueGetterParams) => {
        const editAction = (
          <GridActionsCellItem
            icon={<EditIcon />}
            title="Edit"
            label="Edit"
            sx={{paddingLeft:"55px","&:hover": { backgroundColor:'transparent'},"&:focus":{ backgroundColor:'transparent'}}}
            onClick={() => handleNameClick(params.row)}
          />
        );

        // const deleteAction = (
        //   <GridActionsCellItem
        //     icon={<DeleteIcon />}
        //     title="Delete"
        //     label="Delete"
        //     onClick={deleteSelectedBank(params.row)}
        //   />
        // );

        const actions: JSX.Element[] = [];

        // Push edit action if user has update permission.
        if (canUpdateAccount) {
          actions.push(editAction);
        }

        // Push edit action if user has delete permission.
        // if (canDeleteAccount) {
        //   actions.push(deleteAction);
        // }

        return actions;
      }
    }
  ], [
    //deleteSelected,
    //editSelected,
    canUpdateAccount,
    // canDeleteAccount,
    handleNameClick
  ]);

  const openBankForm = (bankId: string) => {
    setBank(bankId);
    setOpen(true);
  }

  const closeDialog = (isSaved: boolean) => {
    setOpen(false);

    if (isSaved) {
      setFetchData(Math.random().toString());
    }
  }

  return (
    <div className={'c-card2'} style={{ padding: 0 }}>
      <Button
        size='small'
        variant="contained"
        style={{
          float: "right",
          marginRight: 10,
          marginTop: 10,
          color: '#488dff',
          backgroundColor: '#fff',
          border: '0.5px solid #488dff',
          height: 25, borderRadius: 7
        }}
        onClick={() => { openBankForm('') }}
      >Add Bank
      </Button>
      <h5 style={{ fontWeight: 'bold', color: '#000', fontSize: 15, marginLeft: 15, marginTop: 10, marginBottom: 10 }}>Banks</h5>

      {banks && banks.length > 0 ?
        <div style={{ marginBottom: 12, marginTop: 5 }}>
          <Table stickyHeader sx={{ width: '100%' }} size='small' aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell width={235}>Bank Name</StyledTableCell>
                <StyledTableCell width={225}>Branch Name</StyledTableCell>
                <StyledTableCell width={100}>Action</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {banks.map((e: any) =>
                <StyledTableRow key={e._id}>
                  <StyledTableCell>{e.bankName}</StyledTableCell>
                  <StyledTableCell>{e.branchName}</StyledTableCell>
                  <StyledTableCell align='left'>
                    <IconButton
                      onClick={() => handleNameClick(e)}
                      style={{ color: '#488dff', backgroundColor: '#fff', height: 25, width: 25 }}
                      size='small' ><EditIcon style={{ fontSize: 16 }} />
                    </IconButton>
                    <IconButton
                      onClick={() => {
                        // const rows = documentSettings.filter((obj) => obj._id !== e._id);
                        // setDocumentSetting(rows);
                      }}
                      style={{ color: '#c33b3b', backgroundColor: '#fff', height: 25, width: 25, marginLeft: 10 }}
                      size='small' ><DeleteIcon style={{ fontSize: 16 }} />
                    </IconButton>
                  </StyledTableCell>
                  
                  {/* <StyledTableCell>{moment(e.start_date).format("YYYY")} - {moment(e.end_date).format("YYYY")}</StyledTableCell> */}
                </StyledTableRow>
              )}
            </TableBody>
          </Table>
        </div> :
        <div style={{ height: 200 }}>
          <Divider sx={{ mt: 0.5, mb: 1 }} />
          <div style={{ height: 'calc(100% - 20px)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>No Data</div></div>
      }
      <Drawer
            anchor="right"
            open={open}
          >
            {<DialogBankForm open={open} bankId={bankId} onClose={closeDialog}></DialogBankForm>}
          </Drawer>  
    </div>
  );
};

export default AccountBankInfo;
